import { useAtom } from "jotai";
import {
  tasksAtom,
  selectedTaskAtom,
  returnedBubblesAtom,
  hasRunAtom,
  isDraggingBubbleAtom,
  popAtom,
  popPositionAtom,
  categoryImagesAtom,
  hoveredTaskAtom,
} from "../../store/atoms/taskAtoms.js";

// Task State Hook
export const useTasks = () => {
  const [tasks, setTasks] = useAtom(tasksAtom);
  const [selectedTask, setSelectedTask] = useAtom(selectedTaskAtom);
  const [returnedBubbles, setReturnedBubbles] = useAtom(returnedBubblesAtom);
  const [hasRun, setHasRun] = useAtom(hasRunAtom);
  const [isDraggingBubble, setIsDraggingBubble] = useAtom(isDraggingBubbleAtom);
  const [pop, setPop] = useAtom(popAtom);
  const [popPosition, setPopPosition] = useAtom(popPositionAtom);
  const [categoryImages, setCategoryImages] = useAtom(categoryImagesAtom);
  const [hoveredTask, setHoveredTask] = useAtom(hoveredTaskAtom);

  return {
    tasks,
    setTasks,
    selectedTask,
    setSelectedTask,
    returnedBubbles,
    setReturnedBubbles,
    hasRun,
    setHasRun,
    isDraggingBubble,
    setIsDraggingBubble,
    pop,
    setPop,
    popPosition,
    setPopPosition,
    categoryImages,
    setCategoryImages,
    hoveredTask,
    setHoveredTask,
  };
};
